export default "__VITE_ASSET__B0nB9LFA__"